<template>
  <validation-observer
    v-slot="propertyOwnershipObserver"
    key="owned"
    slim
  >
    <form-section
      id="property-owned"
      v-bind="propertyOwnershipObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Do you own or rent your home?"
        :error="formObserver.validated && !propertyOwnershipObserver.valid"
      >
        <validation-provider
          v-slot="{ failed, failedRules }"
          name="Property Ownership"
          :vid="`${stepId}_property-owned`"
          :rules="{ is_not: { other: null } }"
          slim
        >
          <radio
            v-model="propertyOwnedModel"
            name="property-owned"
            column
            wide
            return-object
            :error="failed"
            :error-messages="getFieldErrors('propertyOwned', failedRules)"
            :items="propertyOwnedItems"
            :data-test="snakeCase(questionFields.propertyOwned)"
          />
        </validation-provider>
        <template v-if="!helpers.isNull(questionData.propertyOwned) && isHomeRenting">
          <validation-provider
            id="home_propertyOwned-other"
            v-slot="{ errors, failed }"
            name="Property Ownership Other"
            :vid="`${stepId}_property-owned`"
            rules="listOptionRequired"
            tag="div"
          >
            <qz-select
              v-model="questionData.propertyOwned"
              :items="propertyOwnedOther"
              class="mt-4"
              :error="failed"
              :placeholder="helpers.getPlaceholderResponsiveText('Please select', isMobile)"
              :error-messages="errors"
              :data-test="`${snakeCase(questionFields.propertyOwned)}_other`"
            />
          </validation-provider>
        </template>

        <template #helpText>
          <template v-if="!helpers.isNull(questionData.propertyOwned) && isHomeRenting">
            <p>Council - A tenancy agreement directly through a local council.</p>
            <p>
              Private - This is when the property is let by whoever owns it. The property could be owned by an individual or a business.
              Often the let will be managed by a letting agency.
            </p>
            <p>Housing association - A tenancy agreement set up by a not for profit organisation to help get people into housing.</p>
            <p>If you are not sure, check your rental agreement.</p>
          </template>
          <template v-else>
            <p>If you're renting you'll only need Contents insurance.</p>
          </template>
        </template>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import { omit, pick } from 'lodash';

export default {
  name: 'question-property-owned',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyOwned'],
    };
  },
  computed: {
    propertyOwnedModel: {
      get () {
        if (this.questionData.propertyOwned === null) return null;
        return this.constants.HOME_PROPERTY_OWNED_FAVORITES.includes(this.questionData.propertyOwned) ? this.questionData.propertyOwned : true;
      },
      set (val) {
        this.questionData.propertyOwned = val.logical ? val.logicalValue : val.value;
      },
    },

    propertyOwnedItems   () {
      return [...this.helpers.createOptions({ source: pick(this.constants.HOME_PROPERTY_OWNED, this.constants.HOME_PROPERTY_OWNED_FAVORITES) }), this.helpers.otherOption()];
    },

    propertyOwnedOther () {
      return this.helpers.createOptions({ source: omit(this.constants.HOME_PROPERTY_OWNED, this.constants.HOME_PROPERTY_OWNED_FAVORITES) });
    },

    isHomeRenting () {
      return !this.constants.HOME_PROPERTY_OWNED_FAVORITES.includes(this.questionData.propertyOwned);
    },

    isMobile () { return this.$vuetify.breakpoint.smAndDown; },
  },
};
</script>
